//import 'hammerjs';
import { GoogleAnalyticsService } from "./services/google-analytics.service";
import { MobileChartOptionsModalComponent } from "./components/modals/mobile-chart-options-modal/mobile-chart-options-modal.component";
import { MobileTemplatesModalComponent } from "./components/modals/mobile-templates-modal/mobile-templates-modal.component";
import { TemplatePreviewComponent } from "./components/template-preview/template-preview.component";
import { MobileTutorialVideoWindowComponent } from "./components/mobile-tutorial-video-window/mobile-tutorial-video-window.component";
import { MobileTutorialPanelComponent } from "./components/mobile-tutorial-panel/mobile-tutorial-panel.component";
import { MobileBalanceInfoComponent } from "./components/mobile-balance-info/mobile-balance-info.component";
import { MobileCompetitionRegistrationModalComponent } from "./components/modals/mobile-competition-registration-modal/mobile-competition-registration-modal.component";
import { MobileDisconnectionInfoModalComponent } from "./components/modals/mobile-disconnection-info-modal/mobile-disconnection-info-modal.component";
import { MobileTradeDeskTabsComponent } from "./components/mobile-trade-desk-tabs/mobile-trade-desk-tabs.component";
import { MobileTradeDeskHistoryTabComponent } from "./components/mobile-trade-desk-history-tab/mobile-trade-desk-history-tab.component";
import { MobileUserProfileModalComponent } from "./components/modals/mobile-user-profile-modal/mobile-user-profile-modal.component";
import { MobileAddSymbolToBasketComponent } from "./components/modals/mobile-add-symbol-to-basket/mobile-add-symbol-to-basket.component";
import { MobileSavedStrategiesModalComponent } from "./components/modals/mobile-saved-strategies-modal/mobile-saved-strategies-modal.component";
import { MobileSocialMediaTabComponent } from "./components/mobile-social-media-tab/mobile-social-media-tab.component";
import { MobilePositionEnteredNotificationComponent } from "./components/mobile-position-entered-notification/mobile-position-entered-notification.component";
import { MobileTradeClosedNotificationComponent } from "./components/mobile-trade-closed-notification/mobile-trade-closed-notification.component";
import { MobileOrderNotificationComponent } from "./components/mobile-order-notification/mobile-order-notification.component";
import { MobileNavMenuComponent } from "./mobile-nav-menu/mobile-nav-menu.component";
import { MobileLoginModalComponent } from "./components/modals/mobile-login-modal/mobile-login-modal.component";
import { MobileFooterComponent } from "./components/mobile-footer/mobile-footer.component";
//import { MobileIndicatorModalComponent } from './components/modals/mobile-indicator-modal/mobile-indicator-modal.component';
import { MobileToolbarComponent } from "./components/mobile-toolbar/mobile-toolbar.component";
//import { MobileAlertModalComponent } from './components/modals/mobile-alert-modal/mobile-alert-modal.component';
import { MobileWolfieContextMenuComponent } from "./components/mobile-wolfie-context-menu/mobile-wolfie-context-menu.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DndModule } from "ng2-dnd";
import { ColorAlphaModule } from "ngx-color/alpha"; // <color-alpha-picker></color-alpha-picker>
import { ColorBlockModule } from "ngx-color/block"; // <color-block></color-block>
import { ColorChromeModule } from "ngx-color/chrome"; // <color-chrome></color-chrome>
import { ColorCircleModule } from "ngx-color/circle"; // <color-circle></color-circle>
import { ColorCompactModule } from "ngx-color/compact"; // <color-compact></color-compact>
import { ColorGithubModule } from "ngx-color/github"; // <color-github></color-github>
import { ColorHueModule } from "ngx-color/hue"; // <color-hue-picker></color-hue-picker>
import { ColorMaterialModule } from "ngx-color/material"; // <color-material></color-material>
import { ColorPhotoshopModule } from "ngx-color/photoshop"; // <color-photoshop></color-photoshop>
import { ColorSketchModule } from "ngx-color/sketch"; // <color-sketch></color-sketch>
import { ColorSliderModule } from "ngx-color/slider"; // <color-slider></color-slider>
import { ColorSwatchesModule } from "ngx-color/swatches"; // <color-swatches></color-swatches>
import { ColorTwitterModule } from "ngx-color/twitter"; // <color-twitter></color-twitter>
import { ResizableModule } from "angular-resizable-element";

// services
import { DataService } from "./services/data/data.service";

// components
import { MobileAlertsComponent } from "./components/mobile-alerts/mobile-alerts.component";
import { AppComponent } from "./components/app/app.component";
import { NavMenuComponent } from "./components/navmenu/navmenu.component";
import { HomeComponent } from "./components/home/home.component";
import { CounterComponent } from "./components/counter/counter.component";
import { BoxComponent } from "./components/box/box.component";
import { BoxOpenModeService } from "./services/boxOpenMode/boxOpenMode.service";
import { ResizeService } from "./services/ResizeService/resize.service";
import { chartOpenModeService } from "./services/chartOpenMode/chartOpenMode.service";
import { TimeControl } from "./components/controls/time.control/time.control";
import { AChartComponent } from "./components/achart/achart.component";
import { Loader } from "./components/loader/loader.component";
import { dragAndDropSymbol } from "./services/dragAndDropSymbol/dragAndDropSymbol.service";
import { CommonChartToolBar } from "./components/commonChartToolBar/commonChartToolBar.component";
import { SupportTools } from "./components/supportTools/supportTools.component";
import { ChartPanelComponent } from "./components/chart.panel/chart.panel.component";
import { ChartQuotePanel } from "./components/chart.quotepanel/chart.quotepanel.component";
import { ChartInstanceService } from "./services/chartInstance/chart.instance.service";
import { userSelect } from "./components/userSelect/userSelect.component";
import { providerSelect } from "./components/providerSelect/providerSelect.component";
import { quotePanelTabs } from "./components/quotePanelTabs/quotePanelTabs.component";
import { topRightMenuBar } from "./components/navmenu/topRightMenuBar/topRightMenuBar.component";
import { QuoteSearchComponent } from "./components/quoteSearch/quoteSearch.component";
import { ChartLabelModal } from "./components/modals/chart.label/chart.label.component";
import { QuoteTabsActiveModeService } from "./services/quoteTabsActiveMode/quoteTabsActiveMode.service";
import { tradeDeskTabs } from "./components/tradedeskTabs/tradedeskTabs.component";

import { ChartLayoutModeService } from "./services/chartLayoutMode/chartLayoutMode.service";

import { LandingPageClickStateService } from "./services/landingPageClickStateService/landingPageClickState.service";

import { layoutDisplayModeTabs } from "./components/layoutDisplayModeTabs/layoutDisplayModeTabs.component";
import { ChartDisplayModeService } from "./services/layoutDisplayModeService/layoutDisplayModeService.service";
import { ScrollbarDirective } from "./directives/ScrollbarDirective.directive";
import { QuoteTabWizardComponent } from "./components/quoteTabWizard/quoteTabWizard.component";
import { ScaleBarComponent } from "./components/scaleBar/scaleBar.component";
import { RangeButtonService } from "./services/rangeButtonService/rangeButtonService.service";
import { NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { GlobalGridModeService } from "./services/globalGridMode/globalGridMode.service";
import { IntegerNumberDirective } from "./directives/IntegerNumberDirective.directive";
import { OnlyNumberDirective } from "./directives/OnlyNumberDirective.directive";
import { OrderEntryModal } from "./components/modals/orderentry/orderentry.component";
import { LoginModal } from "./components/modals/login/login.component";
import { StyledchxComponent } from "./components/controls/styledchx/styledchx.component";
import { OrderConfirmationModal } from "./components/modals/orderconfirmation/orderconfirmation.component";
import { quoteFilterTabs } from "./components/quoteFilterTabs/quoteFilterTabs.component";
import { SymbolTypeService } from "./services/quoteFilterTabsActiveMode/quoteFilterTabsActiveMode.service";
import { spaceAfterDataService } from "./services/spaceAfterDataService/spaceAfterData.service";
import { MainUIServiceService } from "./services/main-uiservice.service";
import { QuotesMonitorComponent } from "./components/quotes-monitor/quotes-monitor.component";

import { tradeskOrdersTabComponent } from "./components/tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component";
import { AgGridModule } from "ag-grid-angular";
import { tradeskHistoryTabComponent } from "./components/tradedeskTabs/orders/tradeskHistoryTab/tradeskHistoryTab.component";
import { tradeskPositionsTabComponent } from "./components/tradedeskTabs/orders/tradeskPositionsTab/tradeskPositionsTab.component";
import { CookiesService } from "./tools/cookies.service";
import { OrderDeleteModal } from "./components/modals/orderdelete/orderdelete.component";
import { OrderCellRendererComponent } from "./components/tradedeskTabs/orders/orderCellRendererComponent.component";
import { OrderChangeModal } from "./components/modals/orderchange/orderchange.component";
import { OrderPnlCellRenderer } from "./components/tradedeskTabs/orders/orderPnlCellRenderer.component";
import { OrderPipsCellRenderer } from "./components/tradedeskTabs/orders/orderPipsCellRenderer.component";
import { monitorPeriodsService } from "./services/monitorPeriods/monitorPeriods.service";
import { IndicatorModalComponent } from "./components/modals/IndicatorModal/IndicatorModal.component";
import { ChartOptionsModalComponent } from "./components/modals/ChartOptionsModal/ChartOptionsModal.component";
import { SmallBoxComponent } from "./components/small-box/small-box.component";
import { HeaderBoxesComponent } from "./components/header-boxes/header-boxes.component";
import { DailyOpenService } from "./services/daily-open/daily-open.service";
import { SavedStrategiesModalComponent } from "./components/modals/SavedStrategiesModal/SavedStrategiesModal.component";
import { AlertsComponent } from "./components/alerts/alerts.component";
import { DivideResizerComponent } from "./components/divide-resizer/divide-resizer.component";
import { BalanceInfoComponent } from "./components/balance-info/balance-info.component";
import { TradeClosedInfoComponent } from "./components/modals/tradeclosed-info/tradeclosed-info.component";
import { WolfieContextMenuComponent } from "./components/wolfie-context-menu/wolfie-context-menu.component";
import { WolfieContextMenuService } from "./services/wolfie-context-menu/wolfie-context-menu.service";
import { addsymbolstobasketModal } from "./components/modals/addsymbolstobasket/addsymbolstobasket.component";
import { OrderNotificationModal } from "./components/modals/ordernotification/ordernotification.component";
import { OrderByPipe } from "./pipes/orderby";
import { ReversePipe } from "./pipes/reverse";
import { SelectedParametersSetComponent } from "./components/modals/SelectedParametersSet/SelectedParametersSet.component";
import { CurrencyInputComponent } from "./components/controls/currencyInput/currencyInput.component";
import { demoUsersModal } from "./components/modals/demoUsers/demoUsers.component";
import { AnnotationsService } from "./services/annotations.service";
import { FacebookModule } from "ngx-facebook";
import { dropdownInputComponent } from "./components/controls/dropdownInput/dropdownInput.component";
import { socialMediaTabComponent } from "./components/socialMediaTab/socialMediaTab.component";
import { socialMediaToastrComponent } from "./components/socialMediaToastr/socialMediaToastr.component";
import { socialMediaIconsComponent } from "./components/socialMediaIcons/socialMediaIcons.component";
import { strategyCellRendererComponent } from "./renderers/strategyCellRendererComponent.component";
import { FormattedPriceComponent } from "./components/formatted-price/formatted-price.component";
import { SettingsClient, API_BASE_URL, TournamentClient, AccountsClient } from "./api/DixApiClient";
import { ToastrModule } from "ngx-toastr";
import { OnlyIntDirective } from "./directives/OnlyIntDirective.directive";
import { TradeClosedNotificationComponent } from "./components/trade-closed-notification/trade-closed-notification.component";
import { OrderNotificationComponent } from "./components/order-notification/order-notification.component";
import { WakeUpService } from "./services/wakeUp.service";
import { SocialPostComponent } from "./components/social-post/social-post.component";
import { currencyRenderer } from "./renderers/currencyFormatters.component";
import { PositionEnteredNotificationComponent } from "./components/position-entered-notification/position-entered-notification.component";
import { AppRootComponent } from "./components/app-root/app-root.component";
import { CompetitionInformationComponent } from "./components/competition-information/competition-information.component";
import { SafeHtmlPipe } from "./pipes/safeHtml";
import { competitionRegistrationModal } from "./components/modals/competitionRegistration/competitionRegistration.component";
import { MobileHomeComponent } from "./components/mobile-home/mobile-home.component";
import { MobileAchartComponent } from "./components/mobile-achart/mobile-achart.component";
import { AlertModalComponent } from "./components/modals/alert-modal/alert-modal.component";
import { CountDown } from "./components/countdown/countdown";
import { WistiaVideoComponent } from "./components/wistia-video/wistia-video.component";
import { TutorialVideoWindowComponent } from "./components/tutorial-video-window/tutorial-video-window.component";
import { TutorialPanelComponent } from "./components/tutorial-panel/tutorial-panel.component";
import { mobileSelectComponent } from "./components/controls/mobileselect/mobileselect.component";
import { LeaderBoardComponent } from "./components/leaderBoard/leaderBoard.component";

/**https://github.com/matheushf/ng2-date-countdown */
//import {CountDown} from "ng2-date-countdown";
import { userProfileModal } from "./components/modals/userProfile/userProfile.component";
import { ProviderConnectionModal } from "./components/modals/providerConnection/providerConnection.component";
import { MobileHeaderComponent } from "./components/mobile-header/mobile-header.component";
import { MobileIndicatorModalComponent } from "./components/modals/mobile-indicator-modal/mobile-indicator-modal.component";
import { MobileAlertModalComponent } from "./components/modals/mobile-alert-modal/mobile-alert-modal.component";
import { LandingPageComponent } from "./components/landingPage/landingPage.component";
import { disconnectionInfoModal } from "./components/modals/disconnectionInfo/disconnectionInfoModal.component";
import { MobileQuotesMonitorComponent } from "./components/mobile-quotes-monitor/mobile-quotes-monitor.component";
import { MobileChartQuotepanelComponent } from "./components/mobile-chart.quotepanel/mobile-chart.quotepanel.component";
import { MobileDemoUsersModalComponent } from "./components/modals/mobile-demo-users-modal/mobile-demo-users-modal.component";
import { MobileOrderEntryModalComponent } from "./components/modals/mobile-order-entry-modal/mobile-order-entry-modal.component";
import { MobileQuoteTabWizardComponent } from "./components/mobile-quoteTabWizard/mobile-quoteTabWizard.component";
import { MobileOrderConfirmationModalComponent } from "./components/modals/mobile-order-confirmation-modal/mobile-order-confirmation-modal.component";
import { MobileTradeDeskOrdersTabComponent } from "./components/mobile-trade-desk-orders-tab/mobile-trade-desk-orders-tab.component";
import { MobileLeaderboardComponent } from "./components/mobile-leaderboard/mobile-leaderboard.component";
import { mobileCheckBox } from "./components/controls/mobilecheckbox/mobilecheckbox.component";
import { MobileCompetitionInformationsComponent } from "./components/mobile-competition-informations/mobile-competition-informations.component";
import { MobileLandingPageComponent } from "./components/mobile-landing-page/mobile-landing-page.component";
import { MobileBoxComponent } from "./components/mobile-box/mobile-box.component";
import { MobileBasketSelectorComponent } from "./components/mobile-basket-selector/mobile-basket-selector.component";
import { TemplatesModalComponent } from "./components/modals/templates-modal/templates-modal.component";
import { AfterViewInitDirective } from "./directives/after-view-init.directive";
import { ChallengesComponent } from "./components/challenges/challenges.component";
import { MobileChallengesComponent } from "./components/mobile-challenges/mobile-challenges.component";
import { MobileOrderDeleteComponent } from "./components/modals/mobile-order-delete/mobile-order-delete.component";
import { MobileQuickbarComponent } from "./components/mobile-quickbar/mobile-quickbar.component";
import { DateSelectorComponent } from "./components/date-selector/date-selector.component";
import { SimpleNotificationComponent } from "./components/simple-notification/simple-notification.component";
import { MobileSimpleNotificationComponent } from "./components/mobile-simple-notification/mobile-simple-notification.component";
import { orderTypeCellRenderer } from "./components/tradedeskTabs/orders/orderTypeCellRenderer.component";
import { PrinterComponent } from "./components/printer/printer.component";
import { CookiesInfoComponent } from "./components/cookies-info/cookies-info.component";
import { RoutingService } from "./services/routing.service";
import { orderQtyCellRenderer } from "./components/tradedeskTabs/orders/orderQtyCellRenderer.component";
import { Carousel } from "./components/controls/carouselAll/carouselAll.component";
import { PageComponent } from "./components/controls/carouselAll/pageComponent.component";
import { ScannerTabComponent } from "./components/scanner/scannerTab/scannerTab.component";
import { ScannerResultsComponent } from "./components/scanner/scanner-Results/scanner-Results.component";
import { ScannerSearchTermsComponent } from "./components/scanner/scanner-searchTerms/scanner-searchTerms.component";
import { ScannerChWizardSelectorComponent } from "./components/scanner/scanner-chWizardSelector/scanner-chWizardSelector.component";
import { challengesHistoryComponent } from "./components/modals/challengesHistory/challengesHistory.component";
import { challengesHistoryListComponent } from "./components/tradedeskTabs/orders/challengesHistoryList/challengesHistoryList.component";
import { DateSelectorChallengeComponent } from "./components/date-selector-challenges/date-selector-challenges.component";
import { ScannerEntrySignalsSelectorComponent } from "./components/scanner/scanner-EntrySignalsSelector/scanner-EntrySignalsSelector.component";
import { AdSpaceComponent } from "./components/adSpace/adSpace.component";

import { ScannerRSISelectorComponent } from "./components/scanner/scanner-charting/scanner-RSISelector/scanner-RSISelector.component";
import { ScannerBollingerBandsSelectorComponent } from "./components/scanner/scanner-charting/scanner-BollingerBands/scanner-BollingerBands.component";
import { ScannerEMASelectorComponent } from "./components/scanner/scanner-charting/scanner-EMA/scanner-EMA.component";
import { ScannerMACDSelectorComponent } from "./components/scanner/scanner-charting/scanner-MACD/scanner-MACD.component";

import { Ng5SliderModule } from "ng5-slider";
import { saveScanComponent } from "./components/modals/saveScan/saveScan.component";
import { SavedScansComponent } from "./components/scanner/savedScans/savedScans.component";
import { scanDeleteModalComponent } from "./components/modals/scanDelete/scanDelete.component";
import { ScannerTiWizardSelectorComponent } from "./components/scanner/scanner-tiWizardSelector/scanner-tiWizardSelector.component";
import { ScannerNarrowScannerComponent } from "./components/scanner/scanner-NarrowScanner/scanner-NarrowScanner.component";
import { ServicesClientEx } from "./api/ServicesClientEx";
import { YesNoModal } from "./components/modals/yesno/yesno.component";
import { liveUsersModal } from "./components/modals/liveUsers/liveUsers.component";
import { MobileYesNoModal } from "./components/modals/mobile-yesno/mobile-yesno.component";
import { MobileLiveUsersModalComponent } from "./components/modals/mobile-live-users-modal/mobile-live-users-modal.component";
import { ScannerTrialPopup } from "./components/scanner/modals/ScannerTrialPopup/ScannerTrialPopupModal.component";
import { ScannerTrialInfoImages } from "./components/scanner/modals/ScannerTrialInfoImages/ScannerTrialInfoImages.component";
import { ScannerNotificationComponent } from "./components/scanner/modals/scanner-notification/scanner-notification.component";
import { ScannerTrialReminder } from "./components/scanner/modals/ScannerTrialReminder/ScannerTrialReminder.component";
import { AppstoreMainviewComponent } from "./components/appstore/appstore-mainview/appstore-mainview.component";
import { AppproductTileComponent } from "./components/appstore/appproduct-tile/appproduct-tile.component";
import { AppProductView } from "./components/appstore/appproduct-view/appProductView.component";
import { RatingModule } from "ng-starrating";
import { appProductBuyPopup } from "./components/appstore/appproduct-buypopup/appproduct-buypopup.component";
import { AppstoreSuccessComponent } from "./components/appstore/appstore-success-notification/appstore-success-notification.component";
import { SafePipe } from "./pipes/safePipeUrl";
import { AppStoreClientEx } from "./api/AppStoreClientEx";
import { AdsenseModule } from 'ng2-adsense';
import { NgxPopperModule } from 'ngx-popper';
import { ScannerAutoTrial } from "./components/scanner/modals/ScannerAutoTrial/ScannerAutoTrial.component";
import { FullscreenScannerComponent } from "./components/scanner/fullscreen-scanner/fullscreen-scanner.component";
import {noBoundsModal} from "./components/modals/noBounds/noBounds.component";
import {MobileAppstoreMainviewComponent} from "./components/appstore/mobile-appstore-mainview/mobile-appstore-mainview";
import {FullscreenScannerMobileComponent} from "./components/scanner/mobile-fullscreen-scanner/mobile-fullscreen-scanner.component";
import {FaqComponent} from "./components/faq/faq.component";
import {MobileAppProductView} from "./components/appstore/mobile-appproduct-view/mobile-appProductView.component";
import {MobileScannerResultsComponent} from "./components/scanner/mobile-scanner-Results/mobile-scanner-Results.component";
import {ScannerTrialPopupMobile} from "./components/scanner/modals/ScannerTrialPopupMobile/ScannerTrialPopupMobile.component";
import {ScannerTrialInfoImagesMobile} from "./components/scanner/modals/ScannerTrialInfoImagesMobile/ScannerTrialInfoImagesMobile.component";
import {ScannerTrialReminderMobile} from "./components/scanner/modals/ScannerTrialReminderMobile/ScannerTrialReminderMobile.component";
import {LoginProviderModal} from "./components/modals/login-provider/login-provider.component";
import {ProviderGraphicalSelectComponent} from "./components/controls/provider-graphical-select/provider-graphical-select.component";
import {OpenLiveAccountModal} from "./components/modals/open-live-account/open-live-account.component";
import {OpenLiveAccountMobileModal} from "./components/modals/mobile-open-live-account/mobile-open-live-account.component";
import {OrderEntryContent} from "./components/modals/orderentry/orderentry-new-layout.component";
import {chartLinesService} from "./services/chartLinesService";
let useDummyDataService: boolean = false;

@NgModule({
    declarations: [
        AppComponent,
        // components
        SocialPostComponent,
        NavMenuComponent,
        CounterComponent,
        HomeComponent,
        MobileHomeComponent,
        MobileHeaderComponent,
        AppRootComponent,
        BoxComponent,
        TimeControl,
        AChartComponent,
        MobileAchartComponent,
        Loader,
        CommonChartToolBar,
        SupportTools,
        ChartPanelComponent,
        ChartQuotePanel,
        userSelect,
        providerSelect,
        quotePanelTabs,
        quoteFilterTabs,
        tradeDeskTabs,
        MobileTradeDeskTabsComponent,
        topRightMenuBar,
        QuoteSearchComponent,
        layoutDisplayModeTabs,
        ScaleBarComponent,
        QuoteTabWizardComponent,
        HeaderBoxesComponent,
        SmallBoxComponent,
        AlertsComponent,
        MobileAlertsComponent,
        DivideResizerComponent,
        BalanceInfoComponent,
        MobileBalanceInfoComponent,
        TradeClosedInfoComponent,
        WolfieContextMenuComponent,
        MobileWolfieContextMenuComponent,
        CurrencyInputComponent,
        dropdownInputComponent,
        mobileSelectComponent,
        ProviderGraphicalSelectComponent,
        socialMediaTabComponent,
        MobileSocialMediaTabComponent,
        socialMediaToastrComponent,
        socialMediaIconsComponent,
        FormattedPriceComponent,
        CompetitionInformationComponent,
        CountDown,
        WistiaVideoComponent,
        TutorialVideoWindowComponent,
        MobileTutorialVideoWindowComponent,
        TutorialPanelComponent,
        MobileTutorialPanelComponent,
        FaqComponent,
        LeaderBoardComponent,
        MobileToolbarComponent,
        MobileFooterComponent,
        LandingPageComponent,
        MobileNavMenuComponent,
        MobileOrderNotificationComponent,
        MobileTradeClosedNotificationComponent,
        MobilePositionEnteredNotificationComponent,
        MobileQuotesMonitorComponent,
        MobileChartQuotepanelComponent,
        MobileQuoteTabWizardComponent,
        MobileLeaderboardComponent,
        mobileCheckBox,
        MobileCompetitionInformationsComponent,
        MobileLandingPageComponent,
        MobileQuickbarComponent,
        MobileBoxComponent,
        MobileBasketSelectorComponent,
        MobileAppstoreMainviewComponent,
        TemplatePreviewComponent,
        ChallengesComponent,
        MobileChallengesComponent,
        PrinterComponent,
        CookiesInfoComponent,
        ScannerTabComponent,
        ScannerResultsComponent,
        ScannerSearchTermsComponent,
        ScannerChWizardSelectorComponent,
        ScannerEntrySignalsSelectorComponent,
        ScannerRSISelectorComponent,
        ScannerEMASelectorComponent,
        ScannerMACDSelectorComponent,
        ScannerBollingerBandsSelectorComponent,
        ScannerTiWizardSelectorComponent,
        ScannerNarrowScannerComponent,
        SavedScansComponent,
        Carousel,
        PageComponent,
        AdSpaceComponent,
        AppstoreMainviewComponent,
        AppproductTileComponent,
        AppProductView,
        MobileAppProductView,
        FullscreenScannerComponent,
        FullscreenScannerMobileComponent,
        MobileScannerResultsComponent,
        ScannerTrialInfoImagesMobile,
        // modals
        TemplatesModalComponent,
        MobileTemplatesModalComponent,
        ChartOptionsModalComponent,
        MobileChartOptionsModalComponent,
        ChartLabelModal,
        OrderEntryModal,
        OrderEntryContent,
        MobileOrderEntryModalComponent,
        LoginModal,
        LoginProviderModal,
        StyledchxComponent,
        OrderConfirmationModal,
        MobileOrderConfirmationModalComponent,
        OrderDeleteModal,
        OrderChangeModal,
        competitionRegistrationModal,
        MobileCompetitionRegistrationModalComponent,
        IndicatorModalComponent,
        MobileIndicatorModalComponent,
        SavedStrategiesModalComponent,
        MobileSavedStrategiesModalComponent,
        SelectedParametersSetComponent,
        addsymbolstobasketModal,
        MobileAddSymbolToBasketComponent,
        OrderNotificationModal,
        demoUsersModal,
        MobileDemoUsersModalComponent,
        AlertModalComponent,
        MobileAlertModalComponent,
        MobileLoginModalComponent,
        disconnectionInfoModal,
        MobileDisconnectionInfoModalComponent,
        challengesHistoryComponent,
        challengesHistoryListComponent,
        MobileOrderDeleteComponent,
        DateSelectorComponent,
        DateSelectorChallengeComponent,
        saveScanComponent,
        scanDeleteModalComponent,
        noBoundsModal,
        YesNoModal,
        MobileYesNoModal,
        liveUsersModal,
        MobileLiveUsersModalComponent,
        OpenLiveAccountModal,
        OpenLiveAccountMobileModal,
        ScannerTrialPopup,
        ScannerTrialPopupMobile,
        ScannerTrialInfoImages,
        ScannerTrialReminder,
        appProductBuyPopup,
        ScannerAutoTrial,
        ScannerTrialReminderMobile,
        //notifications
        TradeClosedNotificationComponent,
        OrderNotificationComponent,
        PositionEnteredNotificationComponent,
        SimpleNotificationComponent,
        MobileSimpleNotificationComponent,
        ScannerNotificationComponent,
        AppstoreSuccessComponent,
        ///USER
        userProfileModal,
        MobileUserProfileModalComponent,
        ProviderConnectionModal,

        // directives
        AfterViewInitDirective,
        ScrollbarDirective,
        IntegerNumberDirective,
        OnlyNumberDirective,
        OnlyIntDirective,
        QuotesMonitorComponent,
        tradeskOrdersTabComponent,
        MobileTradeDeskOrdersTabComponent,
        tradeskHistoryTabComponent,
        MobileTradeDeskHistoryTabComponent,
        tradeskPositionsTabComponent,
        OrderCellRendererComponent,
        OrderPnlCellRenderer,
        OrderPipsCellRenderer,
        orderTypeCellRenderer,
        strategyCellRendererComponent,
        currencyRenderer,
        orderQtyCellRenderer,
        OrderByPipe,
        ReversePipe,
        SafeHtmlPipe,
        SafePipe
    ],
    entryComponents: [
        MobileFooterComponent,
        // modals
        TemplatesModalComponent,
        MobileTemplatesModalComponent,
        ChartOptionsModalComponent,
        MobileChartOptionsModalComponent,
        ChartLabelModal,

        OrderEntryModal,
        OrderEntryContent,
        MobileOrderEntryModalComponent,
        LoginModal,
        LoginProviderModal,
        OrderConfirmationModal,
        MobileOrderConfirmationModalComponent,
        OrderDeleteModal,
        OrderChangeModal,
        addsymbolstobasketModal,
        MobileAddSymbolToBasketComponent,
        OrderNotificationModal,
        competitionRegistrationModal,
        MobileCompetitionRegistrationModalComponent,
        MobileOrderDeleteComponent,
        challengesHistoryComponent,
        saveScanComponent,
        scanDeleteModalComponent,
        YesNoModal,
        OrderCellRendererComponent,
        OrderPnlCellRenderer,
        OrderPipsCellRenderer,
        strategyCellRendererComponent,
        currencyRenderer,
        orderTypeCellRenderer,
        orderQtyCellRenderer,

        IndicatorModalComponent,
        MobileIndicatorModalComponent,
        SavedStrategiesModalComponent,
        MobileSavedStrategiesModalComponent,
        SelectedParametersSetComponent,
        TradeClosedInfoComponent,
        demoUsersModal,
        MobileDemoUsersModalComponent,
        socialMediaToastrComponent,
        socialMediaIconsComponent,
        AlertModalComponent,
        MobileAlertModalComponent,
        MobileLoginModalComponent,
        MobileAppstoreMainviewComponent,
        disconnectionInfoModal,
        MobileDisconnectionInfoModalComponent,
        liveUsersModal,
        MobileYesNoModal,
        MobileLiveUsersModalComponent,
        ScannerTrialPopup,
        ScannerTrialPopupMobile,
        ScannerTrialInfoImages,
        ScannerTrialReminder,
        AppProductView,
        MobileAppProductView,
        appProductBuyPopup,
        ScannerAutoTrial,
        ScannerTrialInfoImagesMobile,
        ScannerTrialReminderMobile,
        OpenLiveAccountModal,
        OpenLiveAccountMobileModal,
        //notifications
        TradeClosedNotificationComponent,
        OrderNotificationComponent,
        PositionEnteredNotificationComponent,
        MobileOrderNotificationComponent,
        MobileTradeClosedNotificationComponent,
        MobilePositionEnteredNotificationComponent,
        SimpleNotificationComponent,
        MobileSimpleNotificationComponent,
        ScannerNotificationComponent,
        AppstoreSuccessComponent,
        noBoundsModal,
        //USER
        userProfileModal,
        MobileUserProfileModalComponent,
        ProviderConnectionModal
    ],
    imports: [
        CommonModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule.forRoot(),
        NgSelectModule,
        DndModule.forRoot(), // drag and drop
        ColorSketchModule,
        ColorSwatchesModule,
        ColorChromeModule,
        ColorCircleModule,
        ColorCompactModule,
        ResizableModule,
        Ng5SliderModule,
        RatingModule,
        AgGridModule.withComponents([]),
        FacebookModule.forRoot(),
        RouterModule.forRoot([
            { path: "", component: AppRootComponent, pathMatch: "full" },
            { path: "**", component: AppRootComponent },
            { path: "counter", component: CounterComponent }
        ]),
        [
            CommonModule,
            BrowserAnimationsModule, // required animations module
            ToastrModule.forRoot({
                timeOut: 6600,
                progressBar: true,
                onActivateTick: true,
                enableHtml: true
            }) // ToastrModule added
        ],
        AdsenseModule.forRoot({
            adClient: 'ca-pub-8503371146374483',
            adSlot: 2638728369,
        }),
        NgxPopperModule
    ],
    providers: [
        //     {
        //     provide: DataService,
        //     useFactory: ()=> {
        //         return useDummyDataService?new DummyDataService(): new DataService();
        //     }
        // },
        RoutingService,
        DataService,
        CookiesService,
        MainUIServiceService,
        BoxOpenModeService,
        ResizeService,
        chartOpenModeService,
        dragAndDropSymbol,
        QuoteTabsActiveModeService,
        SymbolTypeService,
        spaceAfterDataService,
        ChartLayoutModeService,
        LandingPageClickStateService,
        GlobalGridModeService,
        monitorPeriodsService,
        ChartDisplayModeService,
        RangeButtonService,
        ChartInstanceService,
        DailyOpenService,
        WolfieContextMenuService,
        AnnotationsService,
        WakeUpService,
        GoogleAnalyticsService,
        chartLinesService,
        SettingsClient,
        {
            provide: API_BASE_URL,
            useFactory: getBaseUrl
        },
        TournamentClient,
        AccountsClient,
        ServicesClientEx,
        AppStoreClientEx
    ]
})
export class AppModuleShared { }

export function getBaseUrl() {
    return window.location.origin;
}
